<template>
  <div class="app">
    <h1>5월 마지막주 영화 예매 순위</h1>
    <ul class="movies">
      <li v-for="movie in movies" :key="movie.id" class="item">
        <span class="rank">{{ movie.id }}</span>
        <router-link :to="{ name: 'detail', params: { id: movie.id } }">
          <img v-bind:src="movie.poster" class="posterSize" />
        </router-link>
        <div class="detail">
          <strong class="title">{{ movie.name }}</strong>
          <span class="rate">예매율 <span class="num">{{ movie.rate }}</span></span>
          <router-link :to="{ name: 'detail', params: { id: movie.id } }" class="link">자세히보기</router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  created() {
    // 컴포넌트가 생성될 때, /api/movies에 요청을 보냅니다.
    axios.get('/api/movies')
      .then((response) => {
        this.movies = response.data;
      })
      .catch(err => {
        alert(`Error: ${err.response.status} - ${err.response.statusText}`);
        console.log(err.response.data);
      });
  },
  data() {
    return {
      movies: []
    };
  }
};
</script>

<style>
.movies {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  list-style: none;
  padding: 0;
}
.item {
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  text-align: left;
}
.posterSize {
  width: 100%;
  height: auto;
  max-height: 300px; /* 이미지 최대 높이 설정 */
}
.detail {
  margin-top: 10px;
}
.link {
  display: block;
  margin-top: 10px;
  color: #42b983;
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>